// ZEA — app.js

// ============================================================
// jQuery ready (merged from multiple $(document).ready blocks)
// ============================================================
$(document).ready(function() {

  // Video play icon
  if ($('.video_play_icon').length) {
    $(document).on('click', ".video_play_icon", function(){
      var video = $(this).parent().find('video').get(0);
      var play_button = $(this);
      if (video.paused) {
        video.play();
        play_button.hide();
        $(video).attr("controls", true);
      }
    });
  }

  // Read more / read less toggle on custom reviews
  if ($('.custom_review .review_inner .more_info').length) {
    $(document).on('click', '.custom_review .review_inner .more_info', function(){
      if ($(this).hasClass('read_less')) {
        $(this).removeClass("read_less");
        $(this).parents('.review_more_info').find('.review_desc').addClass('text_ellipsis');
        $(this).find('span').text("READ MORE");
      } else {
        $(this).addClass("read_less");
        $(this).parents('.review_more_info').find('.text_ellipsis').removeClass('text_ellipsis');
        $('.custom_review .review_inner .more_info.read_less span').text("READ LESS");
      }
    });
  }

  // Flickity navigation button positioning
  $(".template_index .flickity-page-dots").each(function(){
    var flickity_dot = $(this).width() / 2;
    var window_width = $(this).parents('.flickity-enabled').width() / 2;
    var btn_postion = (window_width - 37) - flickity_dot;
    $(this).parents('.flickity-enabled').find('.flickity-button.previous').css("left", btn_postion + "px");
    $(this).parents('.flickity-enabled').find('.flickity-button.next').css("right", btn_postion + "px");
  });

  $("#shopify-section-template--22712134041908__video_slider_TaTnjx .flickity-page-dots").each(function(){
    var flickity_dot = $(this).width() / 2;
    var window_width = $(this).parents('.flickity-enabled').width() / 2;
    var btn_postion = (window_width - 37) - flickity_dot;
    $(this).parents('.flickity-enabled').find('.flickity-button.previous').css("left", btn_postion + "px");
    $(this).parents('.flickity-enabled').find('.flickity-button.next').css("right", btn_postion + "px");
  });

  // Tab collections — click
  $(document).on("click", '.tab_collections .collcetion_title', function(){
    $(".tab_collections .collcetion_title.is_active").removeClass('is_active');
    $(".tab_collections .collcetion_title[data_index=" + $(this).attr('data_index') + "]").addClass("is_active");
    $(".tab_collections .tab_collection_list .tab_collection_grid").removeClass("show_grid");
    $(".tab_collections .tab_collection_list .tab_collection_grid[grid_product_id=" + $(this).attr('data_index') + "]").addClass("show_grid");
  });

  // Tab collections — select
  $(document).on("change", '.tab_collections .collection_inner .header .collection_select_box select', function(){
    var current_value = $(".tab_collections .collection_inner .header .collection_select_box select").val();
    $(".tab_collections .tab_collection_list .tab_collection_grid").removeClass("show_grid");
    $(".tab_collections .tab_collection_list .tab_collection_grid[grid_product_id=" + current_value + "]").addClass("show_grid");
  });

  // Discount text on variant change
  update_discountText();
  $(document).on("change", ".rad_variant", function(){
    update_discountText();
  });

});


// ============================================================
// Utilities
// ============================================================

function ToggleMobileMenu() {
  mobile_menu.$data.open = !mobile_menu.$data.open;
}

function update_discountText() {
  if ($("#variantsJSON").length) {
    let $matched, opt_index, val, filtered_var;
    const variants = JSON.parse($("#variantsJSON").text());
    $('.variants_group .rad_variant:checked').each(function(){
      opt_index = $(this).parents(".variant_input").attr("data-index");
      val = $(this).prop('value');
      filtered_var = variants.filter(function(_variant){
        return _variant.options[opt_index] == val;
      });
      filtered_var.map(function(_variant){
        const options = _variant.options.filter(function(opt) { return opt != val; });
        options.map(function(option){
          $matched = $('.variants_group .rad_variant[value="' + option + '"]').parents(".variant_input");
          if (_variant.discount_text != null) $matched.find(".discount_text").text(_variant.discount_text);
        });
      });
    });
  }
}


// ============================================================
// Dawn featured collection grid — ATC
// ============================================================
$(document).on('click', ".dawn_featured_collection_grid .featured_collections .collection_product_list .product_add_to_cart .atc_btn", function(event) {
  event.preventDefault();
  var dawn_grid_pro = $(this).parents('.product_info');
  var atc_btn_id = parseInt(dawn_grid_pro.find(".variant-options .variant-radios .variant-label input:checked").val());
  var selling_plan = dawn_grid_pro.find(".subscription_select_box").val();
  if (dawn_grid_pro.find('input.pro_var[type="hidden"]').length) {
    atc_btn_id = dawn_grid_pro.find('input.pro_var[type="hidden"]').val();
  }
  var data = { id: atc_btn_id, quantity: 1 };
  if (selling_plan) { data.selling_plan = selling_plan; }
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: data,
    success: function(response) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { data: response } }));
    }
  });
});

$(document).on("change", ".dawn_featured_collection_grid .featured_collections .collection_product_list .variant-options .variant-radios .variant-label input", function(){
  var var_price = $(this).attr("data-product-price");
  $(this).parents(".product_info").find(".grid_pro_price").text(var_price);
});


// ============================================================
// DOMContentLoaded (merged from 4 separate listeners)
// ============================================================
document.addEventListener("DOMContentLoaded", function() {

  // --- Review carousels ---
  if (document.querySelector('.custom_review .review_inner .review_list')) {
    document.querySelectorAll('.custom_review .review_inner .review_list').forEach(function(elem) {
      new Flickity(elem, { cellAlign: 'left', contain: true, prevNextButtons: true, pageDots: true, groupCells: true, wrapAround: true });
    });
  }

  // --- Video sliders ---
  if (document.querySelector('.video_slider .video_list')) {
    document.querySelectorAll('.video_slider .video_list').forEach(function(elem){
      new Flickity(elem, { cellAlign: 'left', contain: true, prevNextButtons: true, pageDots: true, groupCells: true, wrapAround: true });
    });
  }

  // --- Marquee width (short delay for layout to settle) ---
  if (document.querySelector('.marquee_list')) {
    setTimeout(function(){
      var r = document.querySelector(':root');
      var firstMarquee = document.querySelector('.marquee_list .marque_list:first-child');
      if (firstMarquee) {
        r.style.setProperty('--marquee-width', '-' + firstMarquee.clientWidth + 'px');
      }
    }, 200);
  }

  // --- Mobile icon-grid carousel ---
  if (document.querySelector('.custom-review-block .icon-grid') && window.screen.width < 450) {
    document.querySelectorAll('.custom-review-block .icon-grid').forEach(function(elem) {
      new Flickity(elem, { cellAlign: 'left', contain: true, prevNextButtons: true, pageDots: true, adaptiveHeight: true, groupCells: true, wrapAround: true });
    });
  }

  // --- Geo-IP shipping info (24-hour localStorage cache) ---
  if (document.querySelector(".shipping_returns")) {
    var CACHE_KEY = 'zea_geo_country';
    var CACHE_TTL = 24 * 60 * 60 * 1000;

    function applyCountry(country) {
      var shippingData = document.getElementById('shipping-data');
      if (!shippingData) return;
      if (country === 'gb') country = 'uk';
      var content = shippingData.dataset[country] || shippingData.dataset.default || '';
      document.querySelectorAll(".shipping_returns").forEach(function(ele) {
        var info = ele.querySelector('[id="shipping-info"]');
        if (info) info.innerHTML = content;
      });
    }

    var skipFetch = false;
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && (Date.now() - cached.ts < CACHE_TTL)) {
        applyCountry(cached.country);
        skipFetch = true;
      }
    } catch(e) {}

    if (!skipFetch) {
      fetch('https://ipinfo.io/json')
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var country = (data.country || 'au').toLowerCase();
          try { localStorage.setItem(CACHE_KEY, JSON.stringify({ country: country, ts: Date.now() })); } catch(e) {}
          applyCountry(country);
        })
        .catch(function() {
          applyCountry('default');
        });
    }
  }

  // --- Product grid variant auto-selection (MutationObserver, 500ms fallback) ---
  function activateProductGridVariants() {
    document.querySelectorAll(".custom_product_grid .product_card").forEach(function(card){
      card.querySelectorAll(".product_variants .pro_var").forEach(function(group){
        var alreadyChecked = group.querySelector('input[type="radio"]:checked');
        if (alreadyChecked) { alreadyChecked.checked = false; }
        var activeInput = group.querySelector('input.active_var');
        if (activeInput) { activeInput.click(); }
      });
    });
  }

  var productGrid = document.querySelector('.custom_product_grid');
  if (productGrid) {
    if (productGrid.querySelector('.product_card')) {
      activateProductGridVariants();
    } else {
      var gridObserver = new MutationObserver(function(mutations, obs) {
        if (productGrid.querySelector('.product_card')) {
          obs.disconnect();
          activateProductGridVariants();
        }
      });
      gridObserver.observe(productGrid, { childList: true, subtree: true });
      setTimeout(function() { gridObserver.disconnect(); activateProductGridVariants(); }, 500);
    }
  }

});

window.addEventListener('load', () => {
    const first_radio = document.querySelector('.col-auto:first-child .rad_variant:not(.default_selected_variant)');
    if (first_radio) {
      first_radio.checked = true;
      first_radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setTimeout(() => {
    const current_radio = document.querySelector('.default_selected_variant.rad_variant');
        if (current_radio) {
          current_radio.checked = true;
          current_radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
  }, 10);
});